import React, { useEffect, useState } from 'react'
import { AppBar, Button, Container, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEqual, cloneDeep } from 'lodash'
import { api } from '../../../services/api'
import DateObject from 'react-date-object'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import HolidaysTable from '../../../components/Tables/HolidaysTable'
import Holidays from '../../../components/Cards/Facility/Holidays'
import DeleteHoliday from '../../../components/Dialogs/DeleteHoliday'
import moment from 'moment'
import { getApartmentList, updateFacility } from '../../../actions/facilities/facilities.actions'

const useStyles = makeStyles((theme) => ({
	root: {
		// flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	}
}))

const init = {
	name: '',
	surcharge_dates: [],
	surcharge_fee: 0,
	restricted_pick_drop_dates: [],
	deposit_required: false
}

const FacilityHolidays = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	const history = useHistory()

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	const loading = useSelector((state) => state.specific.facilities.loading)

	const [holiday, setHoliday] = useState(init)
	const [holidays, setHolidays] = useState([])
	const [isSaveShown, setIsSaveShown] = useState(false)
	const [localLoading, setLocalLoading] = useState(false)
	const [holidayToDelete, setHolidayToDelete] = useState(null)

	useEffect(() => {
		if (selectedFacility?.holidays?.length) {
			let h = selectedFacility.holidays.filter(a => a.type === 'master')
			h.sort((a, b) => {
				return new Date(b.startDate) -  new Date(a.startDate)
			})

			setHolidays(h)
		}
	}, [selectedFacility])

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const saveHoliday = async (h) => {
		try {
			setLocalLoading(true)
			let bod = {
				...h,
				facility_id: selectedFacility._id,
				surcharge_fee: onlyNumbers(h.surcharge_fee),
				surcharge_dates: h.surcharge_dates
					.map((d) => moment(d).format('YYYY-MM-DD')),
				restricted_pick_drop_dates: h.restricted_pick_drop_dates
					.map((d) => moment(d).format('YYYY-MM-DD'))
			}
			let { data } = await api.post(`/specialHolidays`, bod)
			dispatch({ type: 'UPDATE_HOLIDAYS', payload: data.holidays })
			setHoliday(init)
			setLocalLoading(false)
		} catch (e) {
			console.log('eeeeee.....', e)
			setLocalLoading(false)
		}
	}

	const deleteHoliday = async (h) => {
		try {
			setLocalLoading(true)
			let bod = {
				...holidayToDelete
			}

			let { data } = await api.post(`/vacation/remove`, bod)
			dispatch({ type: 'UPDATE_HOLIDAYS', payload: data.holidays })
			setHolidayToDelete(null)
			setHoliday(init)
			setLocalLoading(false)
		} catch (e) {
			console.log('eeeeee.....', e)
			setLocalLoading(false)
		}
	}


	return (
		<div>
			<Container className={classes.root} maxWidth="auto">
				<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
					Holidays
				</Typography>

				<Holidays
					holiday={holiday}
					setHoliday={setHoliday}
					clearHoliday={() => setHoliday(init)}
					saveHoliday={(h) => saveHoliday(h)}
				/>

				{selectedFacility ? (
					<HolidaysTable
						setHoliday={(h) => {
							let bod = {
								...h,
								surcharge_dates: h.surcharge_dates.map(
									(d) => moment(d, 'YYYY-MM-DD').toDate()
								),
								restricted_pick_drop_dates: h.restricted_pick_drop_dates.map(
									(d) => moment(d, 'YYYY-MM-DD').toDate()
								)
							}
							setHoliday(bod)
						}}
						setHolidayToDelete={(h) => setHolidayToDelete(h)}
						holidays={holidays}
					/>
				) : null}
			</Container>

			{loading || localLoading ? <LoadingOverlay /> : null}
			<DeleteHoliday
				isShown={holidayToDelete ? true : false}
				setIsShown={() => setHolidayToDelete(null)}
				deleteHoliday={() => deleteHoliday()}
			/>
		</div>
	)
}

export default FacilityHolidays
